import { useEffect, useState } from 'react';

import { errors, isValid, validator } from 'react-validator';
import { useTranslation } from 'react-i18next';

import { TeacherGetQuestionByIdQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import quizIconBlueSmall from 'assets/icons/quiz-icon-blue-small.svg';
import Button from 'clean/components/common/Button/Button';
import { CreateEditQuestionModel } from 'types/quiz';

import QuizQuestionTitleContent from '../QuizQuestionTitleContent/QuizQuestionTitleContent';

import './OpenQuestion.scoped.scss';
import { useHistory } from 'react-router-dom';

interface OpenQuestionProps {
  createOrUpdateQuestion: (question: CreateEditQuestionModel) => void;
  editQuestion?: TeacherGetQuestionByIdQuery['assignment_questions_by_pk'] | null;
}
const OpenQuestion = (props: OpenQuestionProps) => {
  const { createOrUpdateQuestion, editQuestion } = props;
  const [title, setTitle] = useState<string>();
  const [content, setContent] = useState<string>();
  const [validation, setValidation] = useState({});
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (editQuestion?.id) {
      setTitle(editQuestion.title);
      setContent(editQuestion.content);
    }
  }, [editQuestion]);

  const onCreate = () => {
    const model = { title };
    validator(
      { model },
      {
        'model.title': ['required', 'string'],
      },
      {
        'model.title.required': t('study:title_required'),
      }
    );

    setValidation(errors());
    if (!isValid()) {
      return;
    }
    createOrUpdateQuestion({ title, content, questionOptions: [] });
  };

  return (
    <div className="quizquestion-container">
      <div className="create-quiz-center">
        <div className="title-container">
          <h2 className="new-quiz-title">
            <img alt="Quiz icon blue" src={quizIconBlueSmall} width="21" height="21" />
            {t('quiz:Question.Open')}
          </h2>
        </div>

        <div>
          <QuizQuestionTitleContent
            onTitleChange={value => setTitle(value)}
            onContentChange={value => setContent(value)}
            title={title}
            content={content}
            validation={validation}
          />
        </div>
      </div>
      <div className="button-wrapper">
        <Button
          onClick={() => onCreate()}
          label={t('quiz:Question.Create')}
          variant="filled"
          color="primary"
        />
        <Button onClick={() => history.goBack()} label={t('common:cancel')} color="decline" />
      </div>
    </div>
  );
};

export default OpenQuestion;
